import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "container-centered small"
  }, [_c("h2", [_vm._v("User roles")]), _c("h4", [_vm._v(_vm._s(_vm.fullNameUser))]), _c("div", {
    staticClass: "mt-4"
  }, [_c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      headers: _vm.datatable_headers,
      items: _vm.datatable_items,
      "item-key": "id_user",
      "disable-pagination": "",
      loading: _vm.datatable_loading,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.enabled",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.enabled ? _c("span", [_c(VIcon, {
          attrs: {
            color: "green"
          },
          on: {
            click: function click($event) {
              return _vm.roleChange(item, false);
            }
          }
        }, [_vm._v("fa-check")])], 1) : _c("span", [_c(VIcon, {
          attrs: {
            color: "red"
          },
          on: {
            click: function click($event) {
              return _vm.roleChange(item, true);
            }
          }
        }, [_vm._v("fa-times")])], 1)];
      }
    }])
  })], 1), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn btnEdit",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.goToUserDetails();
      }
    }
  }, [_vm._v(" User details ")]), _vm.canManage() ? _c(VBtn, {
    staticClass: "dfwa-btn btnEdit",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.validateRoles();
      }
    }
  }, [_vm._v(" Save ")]) : _vm._e()], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };